import { useDispatch } from 'react-redux';
import { hideLoading, showLoading } from '../reducers/loadingSlice';

const useLoading = () => {
  const dispatch = useDispatch();

  const show = (id: string) => {
    dispatch(showLoading(id));
  };

  const hide = (id: string) => {
    dispatch(hideLoading(id));
  };

  return { show, hide };
};

export default useLoading;
